import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { actions as dialogActions } from "@Store/Reducers/dialog";

const InsufficientReportDataDialogContent: React.FC = () => {
    const { t } = useTranslation();

    return (
        <Box sx={{ py: 1 }}>
            <Typography variant="h6" sx={{ mb: 1 }}>
                {t("dialogs.channel.insufficient_data_title")}
            </Typography>
            <Typography variant="body2">
                {t("dialogs.channel.insufficient_data_body")}
            </Typography>
        </Box>
    );
};

const InsufficientReportDataDialogActions: React.FC = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch<any>();

    return (
        <Button
            onClick={() => dispatch(dialogActions.hideDialog())}
            variant="contained"
            size="small"
            color="secondary"
            type="button"
        >
            {t("dialogs.ok")}
        </Button>
    );
};

export default {
    content: InsufficientReportDataDialogContent,
    actions: InsufficientReportDataDialogActions,
    title: "Insufficient data for report",
    disableCancelButton: true,
    isGuestData: false,
};
